
export const loadingPhrases = [
  "Analyzing your design challenge...",
  "Finding the best solution...",
  "Processing your inputs...",
  "This is an MVP, calm down...",
  "Designers take time, AI is faster though...",
  "Almost there, please wait...",
  "Generating your personalized plan...",
  "If this feels slow, imagine doing it with sticky notes.",
  "Running design workshops at 100x speed…",
  "Pabs's CPU is a bit slow atm..",
  "Framing your problem, debating it as an AI team...",
  "Kicking off your design sprint… this would normally take weeks.",
];

export const getRandomLoadingPhrase = () => {
  return loadingPhrases[Math.floor(Math.random() * loadingPhrases.length)];
};
